import React, { FC, memo, ReactNode } from 'react'

import useEvent from 'Hooks/useEvent'

import { usePayment } from '../Provider'

import Spreedly from './Spreedly'
import Square from './Square'
import Stripe from './Stripe'

interface Props {
  children: ReactNode
}

const PaymentForm: FC<Props> = ({ children }) => {
  const { gateway, setErrorMessage, setPaymentStatus } = usePayment()

  const handlePaymentReady = useEvent(() => setPaymentStatus('ready'))
  const handlePaymentError = useEvent((errorMessage) => {
    setErrorMessage(errorMessage)
    setPaymentStatus('error')
  })

  return gateway.isStripe ? (
    <Stripe onPaymentError={handlePaymentError}>{children}</Stripe>
  ) : gateway.isSquare ? (
    <Square onPaymentError={handlePaymentError} onPaymentReady={handlePaymentReady}>
      {children}
    </Square>
  ) : gateway.isSpreedly ? (
    <Spreedly onPaymentError={handlePaymentError} onPaymentReady={handlePaymentReady}>
      {children}
    </Spreedly>
  ) : (
    <form>{children}</form>
  )
}

export default memo(PaymentForm)
